import React, { Component, ErrorInfo, ReactNode } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonText } from '@ionic/react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: undefined });
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <IonPage>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Error</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <div className="ion-text-center ion-margin">
              <IonText color="danger">
                <h2>Algo salió mal</h2>
                <p>Ha ocurrido un error inesperado. Por favor, intenta de nuevo.</p>
              </IonText>
              
              <IonButton 
                expand="block" 
                fill="solid" 
                onClick={this.handleReset}
                className="ion-margin-top"
              >
                Intentar de nuevo
              </IonButton>
              
              <IonButton 
                expand="block" 
                fill="clear" 
                onClick={() => window.location.reload()}
                className="ion-margin-top"
              >
                Recargar página
              </IonButton>
            </div>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="ion-margin-top">
                <IonText color="medium">
                  <h4>Detalles del error (solo en desarrollo):</h4>
                  <pre style={{ fontSize: '12px', overflow: 'auto' }}>
                    {this.state.error.message}
                    {'\n\n'}
                    {this.state.error.stack}
                  </pre>
                </IonText>
              </div>
            )}
          </IonContent>
        </IonPage>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
